<template>
    <master-layout>

        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-6">
                <h4 class="page-title m-b-15"><i class="ti-info-alt"></i> {{ $t('support') }}</h4>
            </div>
            <div class="col-sm-6 t_right">
                <div class="clearfix m-b-10">
                    <a href="javascript:history.back();" class="btn btn-white"><i class="fa fa-chevron-circle-left"></i> {{ $t('back') }}</a>
                </div>
            </div>
        </div>

        <div class="card-box">
            <h4 class="m-t-0 header-title"><b>{{ $t('features_and_actions') }}</b></h4>
            <p class="text-muted m-b-20 font-13">{{ $t('support_videos_ptbr') }}</p>

            <div class="row">
                <div class="col-md-4">
                    <div class="sitemap-wrapper">
                        <h5 class="m-b-0"><a href="#" @click.prevent="tour" v-if="member.is_admin && showTourBtn"><i class="icon-plane"></i> {{ $t('start_tour') }}</a></h5>
                        <h5 class="m-b-0"><a href="https://www.youtube.com/watch?v=LkKqUgo_w0Y&index=2&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr" target="_blank"><i class="ti-info-alt"></i> {{ $t('introduction') }}</a></h5>
                        <h5 class="m-b-0"><a href="https://www.youtube.com/watch?v=X6rswFv2D6U&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr&index=1" target="_blank"><i class="ti-pie-chart"></i> {{ $t('dashboard') }}</a></h5>
                        <h5 class="m-b-0"><a href="http://blog.pumpmylead.com/gerencie-seus-processos/" target="_blank"><i class="md-dashboard"></i> {{ $t('pipeline') }}</a></h5>
                        <h5 class="m-b-0"><a href="https://www.youtube.com/watch?v=id6V1Xh7o9k&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr&index=8" target="_blank"><i class="icon-directions"></i> {{ $t('deals') }}</a></h5>
                        <ul class="list-unstyled m-b-0">
                            <li><a href="https://www.youtube.com/watch?v=J6fjYLA0CXI&index=13&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr" target="_blank">{{ $t('filter') }}</a></li>
                            <li><a href="https://www.youtube.com/watch?v=B_L4Acxw_8M&index=10&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr" target="_blank">{{ $t('quick_add') }}</a></li>
                            <!-- <li><a href="#" target="_blank">{{ $t('cadastro_deal') }}</a></li> -->
                            <li><a href="https://www.youtube.com/watch?v=iYMTGL387m8&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr&index=3" target="_blank">{{ $t('access_to_deals') }}</a></li>
                            <li><a href="https://www.youtube.com/watch?v=10kRhTeB6Cs&index=11&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr" target="_blank">{{ $t('follow_up') }}</a></li>
                            <!-- <li><a href="#" target="_blank">{{ $t('quotes') }}</a></li> -->
                            <li><a href="https://www.youtube.com/watch?v=cOSAuJ4-GjI&index=16&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr" target="_blank">{{ $t('emails') }}</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="sitemap-wrapper">
                        <ul class="list-unstyled">
                            <li><a href="https://www.youtube.com/watch?v=zPSYhYtT-_4&index=6&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr" target="_blank">{{ $t('tasks') }}</a></li>
                            <li><a href="https://www.youtube.com/watch?v=gE4KhVL1_Mw&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr&index=5" target="_blank">{{ $t('attachments') }}</a></li>
                            <li><a href="http://blog.pumpmylead.com/pump-my-lead-integra-busca-de-perfis-sociais-a-suas-funcionalidades" target="_blank">{{ $t('lead_research') }}</a></li>
                            <li><a href="https://www.youtube.com/watch?v=qls-tJhoMP4&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr&index=17" target="_blank">{{ $t('lost') }}</a></li>
                            <li><a href="https://www.youtube.com/watch?v=88113X_BsZQ&index=12&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr" target="_blank">{{ $t('sold') }}</a></li>
                            <li><a href="https://www.youtube.com/watch?v=C2KdyWWPiac&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr&index=4" target="_blank">{{ $t('transfer') }}</a></li>
                            <li><a href="https://www.youtube.com/watch?v=KlCsx1mqv5I&index=14&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr" target="_blank">{{ $t('export') }}</a></li>
                        </ul>
                        <h5 class="m-b-0"><a href="http://blog.pumpmylead.com/importacao-de-deals-em-massa" target="_blank"><i class="wi wi-cloud-up"></i> {{ $t('incoming_deals') }}</a></h5>
                        <h5 class="m-b-0"><a href="https://www.youtube.com/watch?v=mqKqrJs-9Oo&index=9&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr" target="_blank"><i class="ti-pencil"></i> {{ $t('quotes') }}</a></h5>
                        <h5 class="m-b-0"><a href="https://www.youtube.com/watch?v=ArAa_4oXdzc&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr&index=18" target="_blank"><i class="ti-calendar"></i> {{ $t('calendar') }}</a></h5>
                        <h5 class="m-b-0"><a href="https://www.youtube.com/watch?v=XfD4fJi68xA&index=15&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr" target="_blank"><i class="ti-email"></i> {{ $t('email_templates') }}</a></h5>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="sitemap-wrapper">
                        <h5 class="m-b-0"><i class="ti-bar-chart"></i> {{ $t('reports') }}</h5>
                        <ul class="list-unstyled">
                            <li><a href="https://www.youtube.com/watch?v=JLHesbQx5d4&list=PLcwjxwX9ZZXeMp-9CL3-Rur6ovi0aM9mr&index=7" target="_blank">{{ $t('sales_report') }}</a></li>
                        </ul>
                        <h5 class="m-b-0"><i class="fa fa-plug"></i> {{ $t('integrations') }}</h5>
                        <ul class="list-unstyled">
                            <li><a href="http://blog.pumpmylead.com/integre-o-pump-com-seu-calendario-favorito/" target="_blank">{{ $t('_integrations.name_ical') }}</a></li>
                            <li><a href="http://blog.pumpmylead.com/integracao-com-formularios-web/" target="_blank">{{ $t('_integrations.name_in-forms') }}</a></li>
                        </ul>
                        <!-- <h5 class="m-b-0"><i class="ti-panel"></i> {{ $t('parameters') }}</h5>
                        <ul class="list-unstyled">
                            <li><a href="#" target="_blank">{{ $t('access_ways') }} </a></li>
                            <li><a href="#" target="_blank">{{ $t('loss_reasons') }} </a></li>
                            <li><a href="#" target="_blank">{{ $t('sources') }} </a></li>
                            <li><a href="#" target="_blank">{{ $t('segments') }} </a></li>
                            <li><a href="#" target="_blank">{{ $t('product_categories') }} </a></li>
                            <li><a href="#" target="_blank">{{ $t('products') }} </a></li>
                            <li><a href="#" target="_blank">{{ $t('packages') }} </a></li>
                            <li><a href="#" target="_blank">{{ $t('suppliers') }} </a></li>
                            <li><a href="#" target="_blank">{{ $t('teams') }} </a></li>
                        </ul> -->
                    </div>
                    <div class="alert alert_default m-0 m-t-20 t_center">
                        <i class="ti-help-alt fa-3x"></i>
                        <h5 class="bold">{{ $t('missing_anything') }}</h5>
                        <div class="row">
                            <div class="col-md-offset-1 col-md-10">
                                <p>{{ $t('support_contact_by_email') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </master-layout>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'Support',
        computed: {
            ...mapGetters({
                member: 'getMember'
            }),
            showTourBtn () {
                return window.innerWidth > 767
            }
        },
        methods: {
            tour () {
                window.localStorage.setItem('pml_tour', true)
                this.$router.push({name: 'dashboard.first-deal'})
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/support/components/Main.vue